import { RuleObject } from 'antd/lib/form';
import { parsePhoneNumberFromString, isPossiblePhoneNumber } from 'libphonenumber-js';

import i18n from '~/i18n';

import { basicValidation } from './basicValidation';

export type Validator = RuleObject['validator'];

const phoneValidation = (): Validator => {
  return basicValidation((rule, value, callback) => {
    try {
      if (!value.startsWith('+971')) {
        throw new Error(i18n.t('Phone number must be in UAE international format (+971)', { ns: 'validation' }));
      }
      
      const formatedValue = value.startsWith('+0') ? value.replaceAll('+0', '971') : value;
      const phoneNumber = parsePhoneNumberFromString(formatedValue, 'AE');
      const number: any = phoneNumber?.number;
      if (!isPossiblePhoneNumber(number, phoneNumber?.country)) {
        throw new Error(i18n.t('Impossible number', { ns: 'validation' }));
      }
      if (!phoneNumber?.isValid()) {
        throw new Error(i18n.t('Invalid number', { ns: 'validation' }));
      }

      callback();
    } catch (err) {
      console.log((err as any).message as string);
      callback((err as any).message as string);
    }
  });
};

export default phoneValidation;
